<template>
  <div class="container">
    <template>
      <div class="placement">
        <div class="placement__header">
          <div class="placement__header__preview">
            <h1 class="medium-title">Edit Placement</h1>
          </div>
        </div>
        <div v-if="!isLoadingAll" class="placement__body">
          <!-- left Content -->
          <div class="placement__body__left">
            <div class="placement__body__left__form">
              <div class="placement__body__left__form__container">
                <div class="placement__body__left__form__container__item__route">
                  <adx-single-search-dropdown
                    :label="`Select Route`"
                    :optionsParam="routeOptions"
                    :errorLabel="`Route`"
                    :value.sync="model.routeDropdown"
                    :ref="dataRef.routeDropdown"
                    :error.sync="errors.routeDropdown"
                    :validation="['NewNotEmpty']"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">General Information</h1>
                <!-- <div class="placement__body__left__form__container__item">
              <adx-single-search-dropdown
                :label="`Brand`"
                :insertAddNew="`true`"
                @addNew="toggleBrandModal"
                :optionsParam="brandOptions"
                :value.sync="model.brandDropdown"
                :ref="dataRef.brandDropdown"
                :error.sync="errors.brandDropdown"
                :validation="['NewNotEmpty']"
              />
                </div>-->
                <div class="placement__body__left__form__container__item">
                  <adx-input
                    :label="`Placement`"
                    :value.sync="model.placementInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3', 'Alphanumeric']"
                    :ref="dataRef.placementInput"
                    :error.sync="errors.placementInput"
                  />
                </div>
                <div class="placement__body__left__form__container__item">
                  <adx-textarea
                    :label="`Description`"
                    :value.sync="model.descriptionInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:256', 'NewMinLength:1', 'Alphanumeric']"
                    :ref="dataRef.descriptionInput"
                    :error.sync="errors.descriptionInput"
                  />
                </div>
                <div class="placement__body__left__form__container__items pricing">
                  <adx-input
                    :frontIcon="`rupiah`"
                    :label="`Price`"
                    :value.sync="model.priceInput"
                    :validation="['NewNotEmpty','NewMaxLength:10', 'NewMinLength:1']"
                    type="number"
                    :ref="dataRef.priceInput"
                    :error.sync="errors.priceInput"
                  />
                  <p v-if="validationError" class="msg-error small-font">error</p>
                  <adx-select-dropdown
                    :label="`Pricing Scheme`"
                    @selected="validatePricingScheme"
                    :options="schemeOptions"
                    :value.sync="model.schemeDropdown"
                    class="dropdown"
                    :validation="['NewNotEmpty']"
                    :ref="dataRef.schemeDropdown"
                    :error.sync="errors.schemeDropdown"
                    :key="reRender"
                  />
                </div>
                <div class="placement__body__left__form__container__items quantity">
                  <adx-input
                    :label="`Quantity`"
                    :value.sync="model.quantityInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.quantityInput"
                    :error.sync="errors.quantityInput"
                  />
                  <adx-checkbox
                    :label="`Set As Unlimited`"
                    :value.sync="model.unlimited"
                    :valueLabel="`unlimited`"
                  />
                  <adx-checkbox
                    :label="`Out Of Stock`"
                    :value.sync="model.outOfStock"
                    :valueLabel="`outoftock`"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Route Details</h1>
                <div class="placement__body__left__form__container__items">
                  <adx-select-dropdown
                    :label="`Vehicle Type`"
                    :options="vehiclesOption"
                    :value.sync="model.vehicleTypeDropdown"
                    class="dropdown"
                    :validation="['NewNotEmpty']"
                    :ref="dataRef.vehicleTypeDropdown"
                    :error.sync="errors.vehicleTypeDropdown"
                    :insertAddNew="`true`"
                    @addNew="toggleVehicleModal"
                  />
                  <adx-input
                    :label="`Number of Trip per Day`"
                    :value.sync="model.dailyTripInput"
                    :validation="['NewNotEmpty' , 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.dailyTripInput"
                    :error.sync="errors.dailyTripInput"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Seats`"
                    :value.sync="model.seatsInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.seatsInput"
                    :error.sync="errors.seatsInput"
                  />
                  <adx-input
                    :label="`Average passengers per day`"
                    :value.sync="model.trafficInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:5', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.trafficInput"
                    :error.sync="errors.trafficInput"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Purchase Restrictions</h1>
                <div class="placement__body__left__form__container__items period">
                  <adx-input
                    :label="`Minimum Period`"
                    :value.sync="model.periodInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:2', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.periodInput"
                    :error.sync="errors.periodInput"
                  />
                  <adx-select-dropdown
                    :options="timeOption"
                    :value.sync="model.month"
                    class="dropdown"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Minimum Quantity`"
                    :value.sync="model.minQuantityInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:2', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="dataRef.minQuantityInput"
                    :error.sync="errors.minQuantityInput"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Lead Time`"
                    :value.sync="model.leadTimeInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:7']"
                    type="number"
                    :ref="dataRef.leadTimeInput"
                    :error.sync="errors.leadTimeInput"
                    :tooltip="`a time period of the earliest campaign can be executed relative from order date. For example, if the lead time is 6 days,
                it means that if an advertisers order today, the campaign will run 6 days from today`"
                    :icon="`day `"
                  />
                  <adx-input
                    :label="`Trail Time`"
                    :value.sync="model.trailTimeInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1']"
                    type="number"
                    :ref="dataRef.trailTimeInput"
                    :error.sync="errors.trailTimeInput"
                    :icon="`day `"
                    :tooltip="`a time period to clean up previous campaign. During this time, new campaign cannot be added. For example,
                billboard has trail time of 2 days. So when a campaign ends on 1st April, new advertisers can only come onboard by 3rd April (assuming no lead time).`"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Images</h1>
                <div
                  v-for="(image, index) in model.images"
                  :key="index"
                  class="placement__body__left__form__container__images__image"
                >
                  <div class="upload-wrapper">
                    <div class="top">
                      <div class="upload-button">
                        <input
                          type="file"
                          accept="image/*"
                          @change="getFile($event, image, index)"
                          :name="`fileUpload`+index"
                          :id="`fileUpload`+index"
                          style="display: none;"
                        />
                        <label :for="`fileUpload`+index" class="button-input">Add Image</label>
                      </div>
                      <div v-if="image.url" class="file-image">
                        <img :src="image.url" />
                      </div>
                      <div class="file-name">
                        <span class="image_name">
                          <label>{{image.name}}</label>
                          <i v-if="image.name" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                        </span>
                        <div class="image_status" v-if="imageLoadings[index] != null">
                          <span v-if="imageLoadings[index]" class="is_loading">Loading...</span>
                          <span
                            v-if="!imageLoadings[index] && image.isSuccess"
                            class="is_success"
                          >Uploaded</span>
                          <span
                            v-if="!imageLoadings[index] && !image.isSuccess"
                            class="is_error"
                          >Error</span>
                        </div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <adx-checkbox
                          :label="`Set as featured image`"
                          :valueLabel.sync="image.isFeatured"
                          :value.sync="image.isFeatured"
                          :inputId="index"
                          @buttonClicked="buttonClicked(image)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="icon-wrapper">
                    <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                  </div>
                </div>
                <div class="line-wrapper">
                  <hr class="line" />
                </div>
                <div class="button">
                  <button @click="addImage(model.images)" class="new">Add new</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Content -->
          <div class="placement__body__right">
            <div class="placement__body__right__status__container">
              <h1 class="subhead">Status ( Optional )</h1>
              <div>
                <adx-checkbox
                  :label="`Public`"
                  :value.sync="model.public"
                  :valueLabel="`unlimited`"
                />
              </div>
              <div>
                <adx-checkbox
                  :label="`Active`"
                  :value.sync="model.active"
                  :valueLabel="`unlimited`"
                />
              </div>
              <p v-if="!userInputted" class="error-message">Please select user owner.</p>
            </div>
            <div class="placement__body__right__status__container tags">
              <h1 class="subhead">Tags ( Optional )</h1>
              <div>
                <adx-input-tag
                  :limit="model.limit"
                  v-model="model.tagsText"
                  :ref="model.dataRef.tagsText"
                  :placeholder="model.placeholder"
                  :read-only="model.readOnly"
                  :validate="model.validate"
                  :add-tag-on-blur="model.addTagOnBlur"
                />
              </div>
              <p v-if="!userInputted" class="error-message">Please select user owner.</p>
            </div>
            <div class="button">
              <button class="btn-regular primary" @click="saveAndValidate">
                Save
                <adx-loading-2 v-if="saveLoading" />
              </button>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <adx-modal
          v-if="isShowBrandModal"
          @modal-close="toggleBrandModal"
          title="Add New Brand"
          type="small"
        >
          <div slot="content" class="placement__modal">
            <div class="placement__modal__top">
              <adx-input
                :value.sync="model.brandInput"
                label="Brand"
                :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3', 'Alphanumeric']"
                :ref="dataRef2.brandInput"
                :error.sync="errors.brandInput"
                @keypress.enter.native="validateBrand"
              />
            </div>
            <div class="placement__modal__bottom">
              <button class="btn-regular secondary" @click="toggleBrandModal">Cancel</button>
              <button class="btn-regular primary save" @click="validateBrand">
                Save
                <adx-loading-2 v-if="modalLoading" />
              </button>
            </div>
          </div>
        </adx-modal>
        <adx-modal
          v-if="isShowVehicleModal"
          @modal-close="toggleVehicleModal"
          title="Add New Vehicle"
          type="small"
        >
          <div slot="content" class="placement__modal">
            <div class="placement__modal__top">
              <adx-input
                :value.sync="model.vehicleInput"
                label="Vehicle"
                :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3', 'Alphanumeric']"
                :ref="dataRef3.vehicleInput"
                :error.sync="errors.vehicleInput"
                @keypress.enter.native="validateVehicle"
              />
            </div>
            <div class="placement__modal__bottom">
              <button class="btn-regular secondary" @click="toggleVehicleModal">Cancel</button>
              <button class="btn-regular primary save" @click="validateVehicle">
                Save
                <adx-loading-2 v-if="modalLoading" />
              </button>
            </div>
          </div>
        </adx-modal>
      </div>
    </template>
    <template v-if="isLoadingAll">
      <div class="container__loadingWrapper">
        <slot name="loading" />
        <adx-loading />
      </div>
    </template>
  </div>
</template>	

<script>
import Loading from "@/components/Loading/Primary";
import LoadingWhite from "@/components/Loading/Secondary-white";
import Input from "@/components/Form/Input";
import SelectDropdown from "@/components/Form/SelectDropdown";
import ListDropdown from "@/components/Dropdown/ListDropdown";
import Checkbox from "@/components/Form/Checkbox";
import TextArea from "@/components/Form/TextArea";
import Dropdown from "@/components/Form/SelectDropdown";
import InputTag from "@/components/Form/InputTag";
import SingleSearchDropdown from "@/components/Dropdown/SingleSearchDropdown";
import Modal from "@/components/Modal";

import Tooltip from "@/components/Tooltip";

import * as validationLib from "@/lib/validation/";
import triggerValidation from "@/lib/triggerValidation";
import { mapGetters } from "vuex";
import { parseErrorGql } from "@/lib/error";
import { restEdge } from "@/api/edgeUrls";
import api from "@/api";
const { helpers, validate } = validationLib;

export default {
  name: "adx-add-new-device",
  components: {
    "adx-input": Input,
    "adx-select-dropdown": SelectDropdown,
    "adx-dropdown": Dropdown,
    "adx-dropdown-list": ListDropdown,
    "adx-checkbox": Checkbox,
    "adx-textarea": TextArea,
    "adx-input-tag": InputTag,
    "adx-single-search-dropdown": SingleSearchDropdown,
    "adx-tooltip": Tooltip,
    "adx-modal": Modal,
    "adx-loading": Loading,
    "adx-loading-2": LoadingWhite
  },
  props: {
    error: {
      required: false
    },
    validationMethod: {
      required: false,
      default: `onBlur`
    },
    validation: {
      required: false
    },
    label: {
      required: false
    },
    isInitial: {
      required: false
    },
    readonly: {
      required: false
    },
    inputId: {
      required: false,
      default: ""
    }
  },
  data() {
    return {
      busPlacement: null,
      count: 0,
      countBrand: 0,
      countRoute: 0,
      countVehicle: 0,
      eventRouteDone: false,
      eventBrandDone: false,
      eventVehicleDone: false,
      eventPlacementDone: false,
      initial: true,
      inputValue: undefined,
      isBrandLoading: true,
      isLoadingAll: false,
      isSaving: true,
      isShowBrandModal: false,
      isRouteLoading: true,
      isShowVehicleModal: false,
      isVehicleLoading: true,
      message: undefined,
      modalLoading: false,
      placementID: null,
      saveLoading: false,
      size: "small",
      type: null,
      userInputted: true,
      valid: undefined,

      brandOptions: [],
      imageLoadings: [],
      routeOptions: [],
      vehiclesOption: [],
      timeOption: [
        {
          id: 0,
          label: "Day",
          value: "day"
        },
        {
          id: 1,
          label: "Week",
          value: "week"
        },
        {
          id: 2,
          label: "Month",
          value: "month"
        },
        {
          id: 3,
          label: "Year",
          value: "year"
        }
      ],
      quantityOption: [
        {
          id: 0,
          label: "Slot",
          value: "slot"
        },
        {
          id: 1,
          label: "Unit",
          value: "pack"
        }
      ],
      schemeOptions: [
        {
          id: 0,
          label: "Day",
          value: "day"
        },
        {
          id: 1,
          label: "Week",
          value: "week"
        },
        {
          id: 2,
          label: "Month",
          value: "month"
        }
      ],
      model: {
        genericId: null,
        categoryDropdown: null,
        routeDropdown: null,
        brandDropdown: null,
        placementInput: null,
        descriptionInput: null,
        priceInput: null,
        estimationImpression: null,
        tripDistance: null,
        schemeDropdown: "month",
        quantityInput: null,
        unlimited: false,
        outOfStock: false,
        vehicleTypeDropdown: null,
        dailyTripInput: null,
        seatsInput: null,
        trafficInput: null,
        periodInput: null,
        month: "month",
        minQuantityInput: null,
        leadTimeInput: null,
        trailTimeInput: null,
        public: false,
        active: false,
        user: null,
        group: null,
        imageIds: [],
        imageFiles: [],
        images: [
          {
            name: null,
            image: null,
            isFeatured: null,
            url: null
          }
        ],
        limit: 100,
        tagsText: [],
        placeholder: "Separate tags with comma",
        readOnly: false,
        validate: "",
        addTagOnBlur: false,
        dataRef: {
          tagsText: "tagsText"
        },
        brandInput: null,
        vehicleInput: null
      },
      dataRef2: {
        brandInput: "brandInput"
      },
      dataRef3: {
        vehicleInput: "vehicleInput"
      },
      dataRef: {
        categoryDropdown: "categoryDropdown",
        routeDropdown: "routeDropdown",
        brandDropdown: "brandDropdown",
        placementInput: "placementInput",
        descriptionInput: "descriptionInput",
        priceInput: "priceInput",
        estimationImpression: "estimationImpression",
        tripDistance: "tripDistance",
        schemeDropdown: "schemeDropdown",
        quantityInput: "quantityInput",
        vehicleTypeDropdown: "vehicleTypeDropdown",
        dailyTripInput: "dailyTripInput",
        seatsInput: "seatsInput",
        trafficInput: "trafficInput",
        periodInput: "periodInput",
        minQuantityInput: "minQuantityInput",
        leadTimeInput: "leadTimeInput",
        trailTimeInput: "trailTimeInput"
      },
      errors: {
        categoryDropdown: null,
        routeDropdown: null,
        brandDropdown: null,
        placementInput: null,
        descriptionInput: null,
        priceInput: null,
        estimationImpression: null,
        tripDistance: null,
        schemeDropdown: null,
        quantityInput: null,
        vehicleTypeDropdown: null,
        dailyTripInput: null,
        seatsInput: null,
        trafficInput: null,
        periodInput: null,
        minQuantityInput: null,
        leadTimeInput: null,
        trailTimeInput: null,
        brandInput: null,
        vehicleInput: null
      },
      routeOptionsDummy: [
        {
          label: "Bandara Soekarno Hatta - Pasar Minggu (Jalur baru)",
          value: 1
        },
        {
          label: "Bandara Soekarno Hatta - Bandung",
          value: 2
        },
        {
          label: "Bandara Soekarno Hatta - Lebak Bulus",
          value: 3
        }
      ],
      reRender: 0
    };
  },
  computed: {
    validationError: function() {
      if (this.error) return this.error;
      return this.valid === undefined ? false : !this.valid;
    },
    ...mapGetters({
      token: "token"
    }),
    isLoading: function() {
      return (this.$apollo.loading && !this.modalLoading) || false;
    }
  },
  apollo: {},
  watch: {
    "model.placementInput": function(newValue) {
      this.model.placementInput =
        newValue.charAt(0).toUpperCase() + newValue.slice(1);
    },
    "model.descriptionInput": function(newValue) {
      this.model.descriptionInput =
        newValue.charAt(0).toUpperCase() + newValue.slice(1);
    },
    "model.brandInput": function(newValue) {
      if (newValue)
        this.model.brandInput =
          newValue.charAt(0).toUpperCase() + newValue.slice(1);
    },
    "model.vehicleInput": function(newValue) {
      if (newValue)
        this.model.vehicleInput =
          newValue.charAt(0).toUpperCase() + newValue.slice(1);
    },
    inputValue: helpers.debounce(function() {
      if (this.validationMethod === `onChange`) {
        if (!this.initial) {
          this.validateInput(this.inputValue);
        } else {
          this.initial = false;
        }
      }
    }, 500),
    value: function() {
      this.inputValue = this.value;
    },
    error: function() {
      if (typeof this.error == "string") {
        this.message = this.error;
      }
    }
  },
  beforeCreate() {},
  created() {
    localStorage.setItem("apollo-token", this.token);
    if (this.$route.params) {
      this.placementID = this.$route.params.id.toString();
    }
    this.$on("event-done", async () => {
      if (
        this.eventRouteDone &&
        this.eventBrandDone &&
        this.eventVehicleDone &&
        this.eventPlacementDone
      ) {
        // Map this data
        await this.mapData(this.busPlacement);
        this.isLoadingAll = false;
      }
    });
  },
  beforeMount() {
    this.$data.inputValue = this.value;
    if (!this.validation) {
      this.$emit(`update:isInitial`, false);
    }
  },
  async mounted() {
    this.isLoadingAll = true;
    this.count = 0;
    this.getBusPlacement();
    this.getDataOptions();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async buttonClicked(image) {
      await this.model.images.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
    },
    async getDataOptions() {
      const response = await api.get(restEdge.formGeneric, {
        needToken: true,
        useRestEdge: true
      });

      if (response.status == 200) {
        const { data } = response;
        // this.populateBrands(data.brands);
        this.populateVehicles(data.vehicles);
        this.populateRoutes(data.routes);
      }
    },
    // async populateBrands(listBrands) {
    //   if (listBrands) {
    //     await listBrands.map(async brand => {
    //       this.brandOptions.push({
    //         id: parseInt(brand.id),
    //         label: brand.title,
    //         value: brand.title
    //       });
    //     });
    //     this.eventBrandDone = true;
    //     this.$emit("event-done");
    //   }
    // },
    async populateVehicles(listVehicles) {
      if (listVehicles) {
        await listVehicles.map(vehicle => {
          this.vehiclesOption.push({
            id: parseInt(vehicle.id),
            label: vehicle.title,
            value: vehicle.title
          });
        });
        this.eventVehicleDone = true;
        this.$emit("event-done");
      }
    },
    async populateRoutes(listRoutes) {
      if (listRoutes) {
        await listRoutes.map(route => {
          this.routeOptions.push({
            id: parseInt(route.id),
            label: route.title,
            value: route.title
          });
        });
        this.eventRouteDone = true;
        this.$emit("event-done");
      }
    },
    async getBusPlacement() {
      const response = await api.get(
        restEdge.getOneBusPlacement(this.$route.params.id),
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (response.status == 200) {
        this.eventPlacementDone = true;
        this.busPlacement = response.data;
        this.mapData(this.busPlacement);
        this.$emit("event-done");
        this.isLoadingAll = false;
      } else {
        this.raiseError("Placement not found!");
        this.$router.push({ name: "busplacement", query: { from: "edit" } });
        this.isLoadingAll = false;
      }
    },
    async mapData(busPlacement) {
      let ids = [];
      let imgs = [];
      if (busPlacement.generic) {
        await busPlacement.contents.map(content => {
          let imgArray = content.content_url.split("/");
          let imgName = imgArray.pop();
          ids.push({ id: parseInt(content.id) });
          imgs.push({
            id: parseInt(content.id),
            name: imgName,
            image: content.content_url,
            url: content.content_url,
            isFeatured: content.is_featured
          });
        });
        this.model.imageIds = await ids;
        this.model.images = await imgs;
        this.model.dailyTripInput = await busPlacement.daily_trip;
        this.model.seatsInput = await busPlacement.seats;
        this.model.trafficInput = await busPlacement.traffic;
        this.model.placementInput = await busPlacement.generic.title;
        this.model.descriptionInput = await busPlacement.generic.description;
        this.model.quantityInput = await busPlacement.generic.quantity;
        this.model.minQuantityInput = await busPlacement.generic.minQuantity;
        this.model.priceInput = await busPlacement.generic.price;
        this.model.schemeDropdown = await busPlacement.generic.pricingPlan;
        this.model.periodInput = await parseInt(busPlacement.generic.minPeriod) || 0;
        this.model.month = await busPlacement.generic.minPeriodPlan;
        this.model.leadTimeInput = await busPlacement.generic.leadPreCampaign;
        this.model.trailTimeInput = await busPlacement.generic.leadPostCampaign;
        this.model.active = await busPlacement.generic.isActive;
        this.model.public = await busPlacement.generic.isPublic;
        this.model.unlimited = await busPlacement.generic.unlimited;
        this.model.outOfStock = await busPlacement.generic.outOfStock;
        this.model.tagsText = (await busPlacement.generic.tagList) || [];
        this.model.routeDropdown = await busPlacement.route.title;
        // this.model.brandDropdown = await busPlacement.generic.brand.title;
        this.model.vehicleTypeDropdown = await busPlacement.vehicle.title;
        this.model.genericId = await busPlacement.generic.id;
      } else {
        this.count = 0;
        this.getBusPlacement();
      }
    },
    getInput(value) {
      this.validateInput(value);
    },
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label);
        if (valid) {
          this.$emit(`update:value`, value);
          this.$emit(`update:error`, false);
        } else {
          this.$emit(`update:error`, !valid);
        }
        this.valid = valid;
        this.message = message;
      } else {
        this.$emit(`update:value`, value);
        this.$emit(`update:error`, false);
      }
      this.$emit(`update:isInitial`, false);
    },
    async saveImage(fileData, image, index) {
      image.loading = true;
      this.$set(this.imageLoadings, index, true);

      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const response = await api.post(restEdge.uploadFile, formData, {
        needToken: true,
        useRestEdge: true,
        headers: { "Content-Type": "multipart/form-data" }
      });

      await this.$nextTick();
      this.$set(this.imageLoadings, index, false);

      if (response.status == 200) {
        image.isSuccess = true;
        image.id = parseInt(response.data.id);
        this.model.imageIds.push({ id: parseInt(response.data.id) });
      } else {
        image.isSuccess = false;
      }
    },
    addImage(images) {
      images.push({
        id: null,
        name: null,
        image: null,
        isFeatured: null,
        url: null
      });
      this.imageLoadings.push(null);
    },
    deleteImages(image, index) {
      image.splice(index, 1);
      this.imageFiles = this.imageFiles.splice(index, 1);
      this.imageLoadings.splice(index, 1);
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    getRefs(index) {
      return `fileUpload${index}`;
    },
    cancelImage(index) {
      this.model.images[index].id = null;
      this.model.images[index].name = null;
      this.model.images[index].image = null;
      this.model.images[index].isFeatured = null;
      this.model.images[index].url = null;
      this.$set(this.imageLoadings, index, null);
    },
    getFile(event, image, index) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0]);
        if (!validated_data.is_valid) {
          // this.error["avatar"] = validated_data.message;
          this.$notify({
            group: "saved",
            title: "Error",
            text: validated_data.message,
            type: "danger"
          });
        } else {
          reader.onload = e => {
            image.url = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
          this.saveImage(input.files[0], image, index);
        }
      }
    },
    validateFile(file) {
      let maxSize = 300000; // 300 kb
      let data = { is_valid: true };
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/);
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false;
          data.message = "Unsupported file type";
          return data;
        }
      } else {
        data.is_valid = false;
        data.message = "Unsupported file type";
        return data;
      }
      if (file.size > maxSize) {
        data.is_valid = false;
        data.message = `File too large.`;
        return data;
      }
      const filename = file.name.split(".")[0];
      if (filename.length > 100) {
        data.is_valid = false;
        data.message = "File name is too long. Maximum size 100 character";
        return data;
      }

      if (filename.includes("/")) {
        data.is_valid = false;
        data.message = "File name has forbidden character";
        return data;
      }
      return data;
    },
    showNotify() {
      this.$notify({
        group: "saved",
        title: "Error",
        text: `Something went wrong. Please refresh the page!`,
        type: "danger"
      });
    },
    async saveAndValidate() {
      window.scrollTo(0, 0);
      let dropdownVal = this.model.routeDropdown;
      let vehicleVal = this.model.vehicleTypeDropdown;
      let brandVal = this.model.brandDropdown;
      let pricingPlanVal = this.model.schemeDropdown;
      let isValid = await triggerValidation(
        this.model,
        this.dataRef,
        this.$refs,
        this.errors
      );
      if (isValid) {
        this.saveLoading = true;
        await window.scrollTo(0, 0);
        let contentIds = [];

        this.model.images.map(image => {
          contentIds.push({
            id: image.id,
            is_featured: image.isFeatured
          });
        });

        let body = {
          id: this.$route.params.id,
          daily_trip: parseInt(this.model.dailyTripInput),
          seats: parseInt(this.model.seatsInput),
          traffic: parseInt(this.model.trafficInput),
          contents: contentIds,
          vehicle: this.getId(this.vehiclesOption, vehicleVal),
          route: this.getId(this.routeOptions, dropdownVal),
          generic: {
            id: this.model.genericId,
            title: this.model.placementInput,
            // owner: null,
            description: this.model.descriptionInput,
            quantity: parseInt(this.model.quantityInput),
            isActive: this.model.active,
            isPublic: this.model.public,
            price: parseInt(this.model.priceInput),
            pricingPlan: pricingPlanVal,
            minPeriod: this.model.periodInput,
            minPeriodPlan: this.model.month,
            minQuantity: parseInt(this.model.minQuantityInput),
            leadPreCampaign: parseInt(this.model.leadTimeInput),
            leadPostCampaign: parseInt(this.model.trailTimeInput),
            unlimited: this.model.unlimited,
            outOfStock: this.model.outOfStock,
            brandId: this.getId(this.brandOptions, brandVal),
            channelNameId: 1
          }
        };

        const response = await api.patch(
          restEdge.updatePlacement(this.$route.params.id),
          body,
          { needToken: true, useRestEdge: true }
        );
        this.saveLoading = false;
        if (response.status === 200) {
          this.$notify({
            group: "saved",
            title: "Success",
            text: `Data successfully saved!`,
            type: "success"
          });
          this.$router.push({ name: "busplacement", query: { from: "edit" } });
        } else {
          this.$notify({
            group: "saved",
            title: "Error",
            text: `Data failed to save`,
            type: "danger"
          });
        }
      } else {
        this.$notify({
          group: "saved",
          title: "Oh Snap!!!",
          text:
            "An error has occured while saving your placement. please completing some task below. and try again.",
          type: "danger"
        });
      }
    },
    async createVehicle() {
      this.modalLoading = true;
      let body = {
        title: this.model.vehicleInput
      };
      const response = await api.post(restEdge.createVehicle, body, {
        needToken: true,
        useRestEdge: true
      });
      if (response.status == 200) {
        this.countVehicle = 0;
        this.getDataOptions();
        this.modalLoading = false;
        this.model.vehicleTypeDropdown = response.data.title;
      }
    },
    async createBrand() {
      this.modalLoading = true;
      let body = {
        title: this.model.brandInput
      };
      const response = await api.post(restEdge.createBrand, body, {
        needToken: true,
        useRestEdge: true
      });
      if (response.status == 200) {
        const { data } = await response;

        this.getDataOptions();
        this.countBrand = 0;
        this.model.brandDropdown = data.title;
        this.modalLoading = false;
      }
    },
    toggleBrandModal() {
      this.isShowBrandModal = !this.isShowBrandModal;
      this.errors.brandInput = null;
      this.model.brandInput = null;
    },
    toggleVehicleModal() {
      this.isShowVehicleModal = !this.isShowVehicleModal;
      this.errors.vehicleInput = null;
      this.model.vehicleInput = null;
    },
    async validateBrand() {
      let isValid = triggerValidation(
        this.model,
        this.dataRef2,
        this.$refs,
        this.errors
      );
      if (isValid) {
        await this.createBrand();
        this.toggleBrandModal();
      }
    },
    async validateVehicle() {
      let isValid = triggerValidation(
        this.model,
        this.dataRef3,
        this.$refs,
        this.errors
      );
      if (isValid) {
        await this.createVehicle();
        this.toggleVehicleModal();
      }
    },
    getId(options, value) {
      let id = null;
      for (let it = 0; it < options.length; it++) {
        if (options[it].value === value) {
          id = options[it].id;
        }
      }
      return id;
    },
    validatePricingScheme(items) {
      if (items.item.value !== "month") {
        this.$notify({
          group: "saved",
          title: "Oh Snap!!!",
          text: "You only allowed to choose monthly pricing scheme.",
          type: "danger"
        });
        this.reRender += 1;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang='scss'>
@import "~@/styles/variables";
@import "~@/styles/mixins";

.placement {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }

            .popup {
              &__input {
                max-width: 100%;
                margin-left: 48px;
              }
            }
          }
        }
      }
    }
  }

  .vue-input-tag-wrapper .new-tag {
    margin-top: 0px;
  }

  .input-tag {
    max-height: max-content;
  }

  .selectDropdown {
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .icon-info-alt:before {
    content: "\e945";
    color: $reddish-pink;
    font-size: 14px;
  }

  .btn-regular {
    min-width: 32px;
    height: 45px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }
}
.tooltip {
  position: absolute;
  top: 23px;
  right: 9px;

  &.top {
    .tooltiptext {
      min-width: 240px;
      // padding: 20px 0;
      padding: 16px;
      text-align: left;
    }
  }
}
.frontIcon {
  width: 1px;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
